import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity';
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem';
export class PlanillaPartidoOficialAuxiliarAssertions extends AssertionEntity {
  private constructor() {
    super();
  }

  static build() {
    const instance = new this();
    instance.addAssertionForName();
    instance.addAssertionForApellido();
    instance.addAssertionForDNI();
    instance.addAssertionForOrden();
    return instance;
  }

  addAssertionForName(key = 'ppoa_nombre') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Es obligatorio'
      )
    );
  }

  addAssertionForApellido(key = 'ppoa_apellido') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Es obligatorio'
      )
    );
  }

  addAssertionForDNI(key = 'ppoa_dni') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Es obligatorio'
      )
    );
  }

  addAssertionForOrden(key = 'ppoa_orden') {
    this.defineAssertionForProperty(
      key,
      AssertionItem.forClosure(
        (value) => {
          return value !== '';
        },
        key,
        'Es obligatorio'
      )
    );
  }
}
